import { Component, inject, input, output } from '@angular/core';

import { NgIf, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

import { BankAccount } from '@galaxy/billing';
import { LoadingStateService } from '../loading-state.service';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';

@Component({
  standalone: true,
  selector: 'smb-invoicing-bank-account-list',
  templateUrl: './bank-account-list.component.html',
  styleUrls: ['./bank-account-list.component.scss'],
  imports: [
    NgIf,
    GalaxyBadgeModule,
    GalaxyButtonLoadingIndicatorModule,
    TranslateModule,
    MatIcon,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    UpperCasePipe,
  ],
  providers: [TranslateService],
})
export class BankAccountListComponent {
  private loadingStateService = inject(LoadingStateService);

  bankAccounts = input<BankAccount[]>([]);

  setDefaultBankAccount = output<string>();
  deleteBankAccount = output<string>();

  loadingStates = this.loadingStateService.loadingStates;

  setDefault(id: string): void {
    this.setDefaultBankAccount.emit(id);
  }

  delete(id: string): void {
    this.deleteBankAccount.emit(id);
  }
}
